/**
 * 値クラスの生成時、渡された値が invalid だったときに投げる例外のメッセージ定数。
 */
export const invalidInstantiation = 'Invalid instantiation';
